const locationTypes = [
    {
        name: 'Country',
        namePlural: 'Countries',
        key: 'country'
    },
    {
        name: 'Region',
        namePlural: 'Regions',
        key: 'region'
    },
    {
        name: 'Province',
        namePlural: 'Provinces',
        key: 'province'
    },
    {
        name: 'Coast',
        namePlural: 'Coasts',
        key: 'coast'
    },
    {
        name: 'Island',
        namePlural: 'Islands',
        key: 'island'
    },
    {
        name: 'Municipality',
        namePlural: 'Municipalities',
        key: 'municipality'
    },
    {
        name: 'District',
        namePlural: 'Districts',
        key: 'district'
    },
    {
        name: 'Neighbourhood',
        namePlural: 'Neighbourhoods',
        key: 'neighbourhood'
    },
    {
        name: 'Entity',
        namePlural: 'Entities',
        key: 'entity'
    }
];

const xmlLocationTypes = [
    ...locationTypes.map( t => {
        return Object.assign( {
            for: [ t.key ]
        }, t );
    } ),
    {
        name: 'Sub-Entity',
        key: 'subentity',
        for: [ 'entity' ]
    },
    {
        name: 'Sub-Municipality',
        key: 'submunicipality',
        for: [ 'district', 'neighbourhood', 'entity' ]
    }
];

const locationTypeDescriptions = [
    ...locationTypes.map( t => {
        return Object.assign( {
            for: [ t.key ]
        }, t );
    } ),
    {
        name: 'Urbanization in Province',
        key: 'urbanization-in-province',
        for: [ 'entity' ]
    },
    {
        name: 'Region in Province',
        key: 'region-in-province',
        for: [ 'region' ]
    },
    {
        name: 'Area in Province',
        key: 'area-in-province',
        for: [ 'entity' ]
    },
    {
        name: 'Municipality Standalone',
        key: 'municipality-standalone',
        for: [ 'municipality' ]
    },
    {
        name: 'Neighbourhood in District',
        key: 'neighbourhood-in-district',
        for: [ 'neighbourhood' ]
    }
];

const locationPredicates = [
    {
        name: 'Located In',
        key: 'locatedIn'
    }
];

const requiredLocationParentTypes = {
    'country': [],
    'region': [
        'country'
    ],
    'province': [
        'country',
        'region'
    ],
    'island': [
        'country',
        'region'
    ],
    'coast': [
        'country',
        'region',
        'province'
    ],
    'municipality': [
        'country',
        'region',
        'province'
    ],
    'district': [
        'country',
        'region',
        'province',
        'municipality'
    ],
    'neighbourhood': [
        'country',
        'region',
        'province',
        'municipality'
    ],
    'entity': [
        'country',
        'region',
        'province',
        'municipality'
    ]
};

function getLocationTypeSortValue( type ) {
    switch ( type ) {
    case 'country':
        return 1;
    case 'region':
        return 2;
    case 'island':
        return 3;
    case 'province':
        return 4;
    case 'coast':
        return 5;
    case 'municipality':
        return 6;
    case 'district':
        return 7;
    case 'neighbourhood':
        return 8;
    case 'entity':
        return 9;
    }
    return 0;
}

export {
    xmlLocationTypes,
    locationTypeDescriptions,
    locationPredicates,
    requiredLocationParentTypes,
    getLocationTypeSortValue
};

export default locationTypes;



// WEBPACK FOOTER //
// ./src/models/location-types.js